import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LocationSelector = ({ locations, onLocationSelect, orderType, onOrderTypeChange }) => {
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  const handleLocationSelect = (location) => {
    setSelectedLocationId(location.id);
    onLocationSelect(location);
  };

  return (
    <div className="card-surface">
      <div className="mb-6">
        <h2 className="font-headline text-2xl font-bold text-text-primary mb-2">
          Choose Your Experience
        </h2>
        <p className="text-text-secondary">
          Select pickup or delivery and your preferred location
        </p>
      </div>

      {/* Order Type Selection */}
      <div className="flex space-x-4 mb-8">
        <button
          onClick={() => onOrderTypeChange('pickup')}
          className={`flex-1 p-4 rounded-lg border-2 transition-organic ${
            orderType === 'pickup' ?'border-primary bg-primary-50 text-primary' :'border-gray-200 hover:border-primary-200'
          }`}
        >
          <div className="flex items-center justify-center space-x-3">
            <Icon name="MapPin" size={24} />
            <div className="text-left">
              <div className="font-semibold">Pickup</div>
              <div className="text-sm opacity-75">Ready in 15-20 min</div>
            </div>
          </div>
        </button>
        
        <button
          onClick={() => onOrderTypeChange('delivery')}
          className={`flex-1 p-4 rounded-lg border-2 transition-organic ${
            orderType === 'delivery' ?'border-primary bg-primary-50 text-primary' :'border-gray-200 hover:border-primary-200'
          }`}
        >
          <div className="flex items-center justify-center space-x-3">
            <Icon name="Truck" size={24} />
            <div className="text-left">
              <div className="font-semibold">Delivery</div>
              <div className="text-sm opacity-75">$2.99 delivery fee</div>
            </div>
          </div>
        </button>
      </div>

      {/* Location Selection */}
      <div className="space-y-4">
        <h3 className="font-semibold text-text-primary mb-4">Select Location</h3>
        {locations.map((location) => (
          <div
            key={location.id}
            onClick={() => handleLocationSelect(location)}
            className={`p-4 rounded-lg border-2 cursor-pointer transition-organic ${
              selectedLocationId === location.id
                ? 'border-primary bg-primary-50' :'border-gray-200 hover:border-primary-200'
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h4 className="font-semibold text-text-primary">{location.name}</h4>
                <p className="text-text-secondary text-sm mb-2">{location.address}</p>
                <div className="flex items-center space-x-4 text-sm">
                  <div className="flex items-center space-x-1 text-trust-600">
                    <Icon name="Clock" size={16} />
                    <span>{location.estimatedTime}</span>
                  </div>
                  <div className="flex items-center space-x-1 text-text-secondary">
                    <Icon name="Phone" size={16} />
                    <span>{location.phone}</span>
                  </div>
                  {orderType === 'delivery' && (
                    <div className="flex items-center space-x-1 text-accent-600">
                      <Icon name="MapPin" size={16} />
                      <span>{location.deliveryZone} mi radius</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="ml-4">
                {selectedLocationId === location.id && (
                  <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                    <Icon name="Check" size={16} className="text-white" />
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Map Preview */}
      {selectedLocationId && (
        <div className="mt-6">
          <div className="h-48 rounded-lg overflow-hidden">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title={locations.find(l => l.id === selectedLocationId)?.name}
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${locations.find(l => l.id === selectedLocationId)?.coordinates.lat},${locations.find(l => l.id === selectedLocationId)?.coordinates.lng}&z=14&output=embed`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationSelector;